(function ($) {

  var section = $('.col-three-grid.resource'), items = $('.col-three-grid.resource .wrapper .item'), norecord = $('.col-three-grid.resource .wrapper .no-record'), $pagination = $('.col-three-grid.resource .wrapper .pagination'), clear = $('.col-three-grid.resource .wrapper .filter-container .btn-wrap'),solutionFilter = $('.col-three-grid.resource .filter ul li');

  var productsPerPage = 9;pagination("without-filter");

  solutionFilter.on('click', function () {
    updateURL();
    var currentLi = $(this).attr("data-id"), currentLitext = $(this).text(),
      dataId = $(".filter-container .filter span"), dataIDS = [];
    $(this).parent().parent().parent().find("span").text(currentLitext).attr('data-id', currentLi);
    dataId.each(function () { var ID = $(this).attr('data-id'); dataIDS.push(ID) });
    if (dataIDS[0] === "all" && dataIDS[1] === 'all') {
      clear.hide();
      items.removeClass('filtered filter-hide hide').addClass('show');
      items.slice(productsPerPage).addClass('hide');
      pagination("without-filter");
    } else {
        clear.show();
        items.removeClass('filtered filter-hide').addClass('hide');
        $pagination.pagination('drawPage', 1);
      if ($(".col-three-grid.resource").hasClass('case-study')) {
        $('.col-three-grid.resource .wrapper .item[data-solution*="' + dataIDS[0] + '"][data-type*="case-study"]').addClass("filtered show").removeClass('hide');
      } else {
        $('.col-three-grid.resource .wrapper .item[data-solution*="' + dataIDS[0] + '"][data-type*="' + dataIDS[1] + '"]').addClass("filtered show").removeClass('hide');
      }
      var numProductCards = $('.col-three-grid.resource .wrapper .item.filtered').length;
        if (numProductCards > productsPerPage) {
          items.filter('.filtered').slice(productsPerPage).addClass('filter-hide');
          $pagination.pagination({
            items: numProductCards,
            itemsOnPage: productsPerPage,
            prevText: "<span>prev</span>",
            nextText: "<span>next</span>",
            displayedPages: 4,
            ellipsePageSet: true,
            onPageClick: function (pageNumber, e) {
              filteredSwitchPage(pageNumber);
              smoothScrollTo(section);
              e.preventDefault();
              e.stopPropagation();
            },
          });
        } else {
          $pagination.pagination('destroy');
        }
    }
    var recordLI = $('.col-three-grid.resource .wrapper .item').length;
    var totalLi = $('.col-three-grid.resource .wrapper .item.hide').length;
    noRecord(recordLI, totalLi); if ($(".col-three-grid.resource").hasClass('case-study')) {if (dataIDS[0] === "all") {
        clear.hide();
      }}
  });

  clear.on("click", function () {
    $('.col-three-grid.resource .filter span').text("Select").attr('data-id', 'all')
    items.removeClass('filtered filter-hide hide').addClass('show');
    items.slice(productsPerPage).addClass('hide');
    pagination("without-filter");
    clear.hide();
  });

  function switchPage(pageNumber) {
    var showFrom = productsPerPage * (pageNumber - 1);
    var showTo = showFrom + productsPerPage;
    items.addClass('hide');
    items.filter('.show').slice(showFrom, showTo).removeClass('hide');
  }

  function filteredSwitchPage(pageNumber) {
    var showFrom = productsPerPage * (pageNumber - 1);
    var showTo = showFrom + productsPerPage;
    items.filter('.filtered').removeClass('filter show').addClass("filter-hide");
    items.filter('.filtered').slice(showFrom, showTo).removeClass('filter-hide');
  }

  function smoothScrollTo($offset) {
    if ($offset.length) {
      $('html, body').animate({scrollTop: $offset.offset().top - 10,}, 700, 'linear');
    }
  }

  function pagination(type) {
    if (type === 'without-filter') {
      var ProductCards = items.length;
      if (ProductCards > 1) {
        items.addClass('show').slice(productsPerPage).addClass('hide');
        $pagination.pagination({
          items: items.length,
          itemsOnPage: productsPerPage,
          prevText: "<span>prev</span>",
          nextText: "<span>next</span>",
          displayedPages: 4,
          ellipsePageSet: true,
          onPageClick: function (pageNumber, e) {
            e.preventDefault();
            e.stopPropagation();
            switchPage(pageNumber);
            smoothScrollTo(section);
          },
        });
      } else {
        $pagination.pagination('destroy');
      }
    } else if (type === 'with-filter') {
      var numProductCards = $('.col-three-grid.resource .wrapper .item.filtered').length;
      if (numProductCards > 1) {
        items.filter('.filtered').slice(productsPerPage).addClass('filter-hide');
        $pagination.pagination({
          items: numProductCards,
          itemsOnPage: productsPerPage,
          prevText: "<span>prev</span>",
          nextText: "<span>next</span>",
          displayedPages: 4,
          ellipsePageSet: true,
          onPageClick: function (pageNumber, e) {
            e.preventDefault();
            e.stopPropagation();
            filteredSwitchPage(pageNumber);
            smoothScrollTo(section);
          },
        });
      } else {
        $pagination.pagination('destroy');
      }
    }
  }

  function updateURL() {
    var uri = window.location.href;
    var URL = uri.split("#");
    history.replaceState({}, null, URL[0]);
  }

  function noRecord (recordLI, totalLi ) {
    if (totalLi === recordLI ){
      norecord.show();
    }else {
      norecord.hide();
    }
  }

  $('.col-three-grid.resource .wrapper .filter-container .btn-wrap').on('click', function (e) {
    e.preventDefault();
    $(this).parent().parent().find(".no-record").hide();
  });

  function noPage () {
    var $paginationLi = $('.col-three-grid.resource .wrapper .pagination ul li').length;
    if ($paginationLi === 3 || $paginationLi === 0 ) {
      $pagination.hide();
    }else {
      $pagination.show();
    }
  }

})(jQuery);